import React from 'react'
import { Input, Button, Row, Col, message, Modal } from 'antd'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import * as API from '../../../../api'
import './index.less'

export default class SelectUser extends React.Component {
	state = {
		visibleSearch: false,
		searchValue: '',
		searchResult: [],
		userList: []
	}
	componentDidMount() {
	}
	async getUserList() {
		const { code, data, msg } = await API.getCompanyUserList({company_id: this.props.companyId})
		if(code === 0) {
			this.setState({visibleSearch: false, userList: data})
		} else {
			message.error(msg)
			this.setState({visibleSearch: false})
		}
	}
	handleSet() {
		this.props.handleSelectUser()
		if(!this.props.selectUserVisible) this.getUserList()
	}
	setValue(e) {
		this.setState({searchValue: e.currentTarget.value})
		if(e.currentTarget.value === '') {
			this.setState({visibleSearch: false})
		}
	}
	async addUser(data) {
		if(!!this.state.userList.find(item => item.userid === data.userId)) return
		const { code, msg } = await API.addUser({company_id: this.props.companyId, user_id: [data.userId]})
		if(code === 0) {
			const userList = this.state.userList
			userList.push({username: data.username, userid: data.userId})
			this.setState({visibleSearch: false, searchValue: ''})
		} else {
			message.error(msg)
			this.setState({visibleSearch: false})
		}
	}
	async delUser(userid){
		Modal.confirm({
			title: '提示',
			content: '是否删除该用户',
			onOk: async () => {
				const {code, msg} = await API.delUser({company_id: this.props.companyId, user_id: [userid]})
				if(code === 0) {
					const userList = this.state.userList
					userList.map((item, index) => {
						if(item.userid === userid) userList.splice(index, 1)
					})
					this.setState({userList})
				} else {
					message.error(msg)
				}
			}
		})
	}
	async searchUser() {
		const searchValue = this.state.searchValue
		if(!searchValue) return
		const params = {}
		if(/^1\d{10}$/.test(searchValue)){
			params.user_phone = searchValue
		} else {
			params.username = searchValue
		}
		const {code, data, msg} = await API.userSearch(params)
		if(code === 0) {
			this.setState({
				visibleSearch: true,
				searchResult: data
			})
		} else {
			message.error(msg)
		}
	}
	render() {
		const {visibleSearch, searchValue, searchResult, userList } = this.state
		const getDisable = (userid) => {
			return !!userList.find(item => item.userid === userid)
		}
		const { selectUserVisible } = this.props
		return (
			<div className="user-select-wrap">
				<div className="user-select-btn" onClick={this.handleSet.bind(this)}>
					权限设置
					{
						selectUserVisible ? <CaretUpOutlined /> : <CaretDownOutlined/>
					}
				</div>
				<div className={`user-select-content ${selectUserVisible ? 'active' : ''}`}>
					<div className="select-hd">
						<Row>
							<Col span={16}>
								<Input placeholder="请输入姓名或手机号" value={searchValue} onChange={this.setValue.bind(this)}/>
							</Col>
							<Col span={1}> </Col>
							<Col span={7}>
								<Button type="primary" onClick={this.searchUser.bind(this)}>搜索</Button>
							</Col>
						</Row>
						<div className={`search-result ${visibleSearch ? 'active' : ''}`}>
							{searchResult.map(item => {
								return (
									<div key={item.userId} className={`search-item ${getDisable(item.userId) ? 'disable' : ''}`} onClick={this.addUser.bind(this,item)}>{item.username}</div>
								)
							})}
						</div>
					</div>
					<div className="select-bd">
						<div className="user-list">
							{userList.map(item => {
								return (
									<div className="user-item" key={item.userid}>
										<span className="check"></span>
										<span className="name">{item.username}</span>
										<span className="del" onClick={this.delUser.bind(this,item.userid)}></span>
									</div>
								)
							})}
						</div>
					</div>
				</div>

			</div>
		)
	}
}